import { Text } from "@mantine/core"
import { useSuspenseQueryGet } from "@/typed-client/hooks/use-suspense-query-get"
import { useBatchedSimplePerson } from "@/-dataloaders/simple-persons"
import { getFormattedDate } from "@/utils/get-formatted-date"
import { t } from "i18next"

export function CastTitle({
  castId,
  onTitleChange,
}: {
  castId: number
  onTitleChange?: (title: string) => void
}) {
  const { data: castInfo } = useSuspenseQueryGet(
    "/api/Casts/GetActivityAndPersonForCast",
    { castId }
  )
  const activityId = castInfo?.activityId
  const { data: activity } = useSuspenseQueryGet(
    "/api/Activity/GetActivity",
    activityId !== undefined ? { activityId } : { activityId: -1 }
  )
  const personId = castInfo?.personId
  const { data: person } = useBatchedSimplePerson(personId)
  let title: string
  if (
    !activity ||
    !person ||
    activityId === undefined ||
    personId === undefined ||
    activityId === -1 ||
    personId === -1
  ) {
    title = t("DeletedOrNoPermission")
    onTitleChange?.(title)
    return (
      <Text span inherit>
        {title}
      </Text>
    )
  }
  const dateString = getFormattedDate(activity?.date)
  title =
    (dateString + (person?.name ? " " + person.name : "")).trim() ||
    `Cast #${castId}`
  React.useEffect(() => {
    onTitleChange?.(title)
  }, [title, onTitleChange])
  return (
    <Text span inherit>
      {title}
    </Text>
  )
}
